import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { requirePermission } from "@/lib/casl/route-guards.ts";
import { TRAINING_COMPLETION_SCREENS } from "@/lib/api/training-simulator/training-simulator";
import { TrainingCompletion } from "@/components/training-simulator/completion/training-completion.tsx";

// `screen` is a dev-only override to preview the otherwise hard-to-reach
// module/simulator screens; production routing uses the attempt's API state.
const searchSchema = z.object({
  screen: z.enum(TRAINING_COMPLETION_SCREENS).optional(),
});

export const Route = createFileRoute(
  "/_authenticated/training/complete/$attemptId",
)({
  component: TrainingCompletionRoute,
  validateSearch: searchSchema,
  beforeLoad: ({ context }) => {
    requirePermission(context.user, "read", "training-simulator");
  },
});

function TrainingCompletionRoute() {
  const { attemptId } = Route.useParams();
  const { screen } = Route.useSearch();

  return (
    <TrainingCompletion
      attemptId={attemptId}
      screenOverride={import.meta.env.DEV ? screen : undefined}
    />
  );
}
